import React from 'react';
import SearchableDropdown from './SearchableDropdown';
import { DropdownOption } from './DropdownOption';

interface MonthFilterProps {
  selectedMonth: number | null;
  onMonthChange: (month: number) => void;
}

export const SearchableMonthFilterDropdown = React.forwardRef<HTMLElement, MonthFilterProps>((props, ref) => {
  const { selectedMonth, onMonthChange } = props;

  const months: DropdownOption[] = Array.from({ length: 12 }, (_, i) => ({
    text: new Date(0, i).toLocaleString('en-US', { month: 'long' }),
    value: i.toString()
  }));

  const defaultItem = { text: "Select Month", value: "" };

  return (
    <SearchableDropdown
      label="Month"
      name="month"
      options={months}
      value={
        selectedMonth !== null 
        ? months.find((option) => option.value === selectedMonth?.toString())
        : defaultItem}
      onChange={(e) => onMonthChange(e.target.value.value as number)}
      defaultItem={defaultItem}
    />
  );
});

SearchableMonthFilterDropdown.displayName = 'MonthFilter';

export default SearchableMonthFilterDropdown;
